export default {
  baseLayoutSubtitle: 'Platí pre každú správu, pokiaľ správa nastavenie neprepíše.',
};
